import { Modal } from "antd";
import React, { useState } from "react";
import Preview from "../../../../../../Assets/Images/Svg/PreviewIcon.svg";

function LabCard({ labTest, key }) {
  const [testViewMod, setTestViewMod] = useState(false);

  const handlView = () => {
    setTestViewMod(!testViewMod);
  };

  const formatDate = (dateTime) => {
    const date = new Date(dateTime);
    return date.toISOString().split("T")[0];
  };

  return (
    <div key={key}>
      <div className="bg-white shadow rounded-xl border mb-4">
        <div className="flex items-center justify-between p-3 border-b">
          <span className="text-xs font-sans text-[#333333] font-semibold">
            {labTest.labTestOrderId}
          </span>
          <button
            onClick={handlView}
            // className="w-28 h-6 bg-brand-primaryColor text-white font-sans font-medium text-xs rounded-md"
          >
            <img src={Preview} alt="" className="w-6 h-6" role="button" />
          </button>
        </div>
        <div className="p-3 space-y-2">
          <div className="flex gap-3 items-center">
            <p className="text-[#828282] font-sans font-normal text-xs">
              Name of the test:
            </p>
            <p className="text-[#333333] font-sans font-medium text-xs">
              {labTest.labTestName}
            </p>
          </div>
          <div className="flex gap-3">
            <p className="text-[#828282] font-sans font-normal text-xs">
              Diagnostics Name:
            </p>
            <p className="text-[#333333] font-sans font-medium text-xs">
              {labTest.vendorName}
            </p>
          </div>
          <hr />
          <span className="flex items-center gap-2 text-xs font-medium font-sans text-[#333333]">
            {formatDate(labTest.uploadedDateTime)}
          </span>
        </div>
      </div>

      {/* View Test */}
      <Modal
        open={testViewMod}
        onCancel={handlView}
        footer={[]}
        width={"70%"}
        destroyOnClose
      >
        <embed
          src={process.env.REACT_APP_IMAGE_URL + labTest.resultDocumentName}
          type="application/pdf"
          width="100%"
          height="550px"
        />
      </Modal>
    </div>
  );
}

export default LabCard;
